import { defineTracking } from 'services/google-analytics';

const category = 'new landing page - top model summer contest';

export default {
  ...defineTracking({
    joinNowButton: {
      category,
      action: 'click',
      label: 'join now button',
      description: 'This event is triggered when a user clicks the join now button.',
    },
  }),
};
